/**
 * Title panel for the Automations list page.
 */
import {Button} from '@wandb/weave/components/Button';
import React, {useContext, useState} from 'react';

import {useHandleScroll} from '../../../pages/HomePage/HomePageSidebar/useHandleScroll';
import {
  PremiumFeatureTooltip,
  PremiumFeatureToolTipText,
  useIsAutomationEnabled,
} from '../../../util/accounts/pricing';
import {AccountSelectorContext} from '../../Search/SearchNav/AccountSelectorContextProvider';
import {CreateTriggerDrawer} from './CreateTriggerDrawer/CreateTriggerDrawer';
import {getProjectTriggerDrawerInit} from './CreateTriggerDrawer/EventStore';
import * as S from './TriggersHeader.styles';

type TriggersHeaderProps = {
  entityName: string;
  projectID: string;
  projectName: string;
  refetchTriggers: () => Promise<any>;
};

export const TriggersHeader = ({
  entityName,
  projectID,
  projectName,
  refetchTriggers,
}: TriggersHeaderProps) => {
  const scrolled = useHandleScroll();
  const [creatingTrigger, setCreatingTrigger] = useState(false);
  const {selectedAccount} = useContext(AccountSelectorContext);
  const hasAutomationAccess = useIsAutomationEnabled(selectedAccount);

  const closeDrawer = () => {
    setCreatingTrigger(false);
  };

  return (
    <S.Header>
      <CreateTriggerDrawer
        open={creatingTrigger}
        closeDrawer={closeDrawer}
        createTriggerDrawerInit={{
          isUpdating: false,
          trigger: undefined,
          ...getProjectTriggerDrawerInit(
            entityName,
            projectID,
            projectName,
            [] // TODO: get existing automations
          ),
        }}
        refetchProjectTriggers={refetchTriggers}
        scrollWidth={scrolled.scrollWidth}
        showIntercom={false} // Intercom is already displayed from Triggers page
      />

      <S.Title>Automations</S.Title>
      <S.Spacer />
      <S.CreateButton>
        <Button
          icon="add-new"
          onClick={() => {
            setCreatingTrigger(true);
          }}
          disabled={!hasAutomationAccess}
          tooltip={
            !hasAutomationAccess ? (
              <PremiumFeatureToolTipText isPremiumFeatureDisabled={true} />
            ) : undefined
          }
          variant="primary"
          size="large">
          <>
            Create automation
            <PremiumFeatureTooltip
              isPremiumFeatureDisabled={!hasAutomationAccess}
            />
          </>
        </Button>
      </S.CreateButton>
    </S.Header>
  );
};
